if (!customElements.get('file-size')) {
  class FileSize extends HTMLElement {
    constructor() {
      super();
      this.fileUrl = this.getAttribute('data-file-url');

      if (!this.fileUrl) {
        return;
      }

      this.getFileSize();
    }

    getFileSize() {
      fetch(this.fileUrl)
        .then(response => {
          if (response.ok) {
            return response.blob();
          }
          throw new Error('Network response was not ok.');
        })
        .then(blob => {
          const sizeInBytes = blob.size;
          const sizeInMB = (sizeInBytes / (1024 * 1024)).toFixed(2); 

          this.innerHTML = `${sizeInMB.replace('.', ',')} mb`;;
        })
        .catch(error => {
          console.error('There has been a problem with your fetch operation:', error);
        });
    }
  }

  customElements.define('file-size', FileSize);
}
